import React from "react";
import {
	Box,
	IconButton,
	InputAdornment,
	inputBaseClasses,
	MenuItem,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { Field } from "@onair/minimal-ui/hook-form";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { TicketScope } from "@onair/repositories";
import EventSessionTicketTierBox from "./event-session-ticket-tier-box.tsx";
import TicketTierForm from "./";

interface PropTypes {
	disabled?: boolean;
}

const TicketScopeBox: React.FC<PropTypes> = ({ disabled = false }) => {
	const { control } = useFormContext();

	const ticketScope = useWatch({
		name: "stepPricing.ticketScope",
		control,
	});

	const isTicketForAll = ticketScope === TicketScope.ALL;

	const { fields: eventSessions } = useFieldArray({
		control,
		name: "stepTimeline.sessions",
		keyName: "_id",
	});

	return (
		<Stack spacing={3}>
			<Field.Select
				name={`stepPricing.ticketScope`}
				label=""
				sx={{
					flex: 1,
					[`& .${inputBaseClasses.root}`]: {
						backgroundColor: "white",
					},
					[`& p`]: {
						textTransform: "none",
					},
				}}
				required
				value={ticketScope}
				disabled={disabled}
			>
				{[
					{
						label: (
							<Typography variant="body2">
								Mỗi sự kiện lẻ có loại vé giống nhau
							</Typography>
						),
						value: TicketScope.ALL,
					},
					{
						label: (
							<Typography variant="body2">
								Mỗi sự kiện lẻ có loại vé khác nhau
							</Typography>
						),
						value: TicketScope.EACH,
					},
				].map((el) => {
					return (
						<MenuItem key={el.value} value={el.value}>
							{el.label}
						</MenuItem>
					);
				})}
			</Field.Select>

			{isTicketForAll ? (
				<TicketTierForm prefixName={`stepPricing.ticketTiers`} />
			) : (
				<Stack spacing={3}>
					{eventSessions.map((_, index) => (
						<EventSessionTicketTierBox index={index} />
					))}
				</Stack>
			)}
		</Stack>
	);
};

export default TicketScopeBox;
